var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-monitor_map"},[_c('MapLibreGL',{ref:"maplibre",attrs:{"theme":_vm.theme},on:{"loaded":_vm.mapLoaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }